import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {inject} from "@angular/core";
import {LocalStorageService} from "./services/local-storage.service";
import {AccessService} from "./services/access.service";
import {DataService} from "./services/data.service";
import {firstValueFrom} from "rxjs";

export const AdminGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {

    const localStorageService = inject(LocalStorageService);
    const accessService = inject(AccessService);
    const dataService = inject(DataService);
    const router = inject(Router);

    const token = localStorageService.getItem('token');

    if (!token) {
        await gotoLogin();
        return false;
    }

    console.log('Token gefunden, validiere...');
    accessService.token = token;

    const slug = route.parent?.paramMap.get('slug');

    try {
        const response = await firstValueFrom(dataService.request('Client/checkToken', { slug }));

        if (response?.error) {
            // Token ungültig, Benutzer ausloggen
            localStorageService.removeItem('token');
            accessService.client = null;
            accessService.token = '';
            await gotoLogin();
            return false;
        }

        // Token gültig, Zugriff erlauben
        accessService.client = response.client;
        return true;

    } catch (error) {
        console.error('Fehler bei der Token-Validierung:', error);
        await gotoLogin();
        return false;
    }

    async function gotoLogin() {
        const parentUrl = route.parent ? route.parent.url.map(segment => segment.path).join('/') : '';
        await router.navigate([`${parentUrl}/login`]);
    }
};
